export default __webpack_public_path__ + "static/million-dollar-b306548cfb2ffc6e0ae0035e0e3ffed9.png";